import type { Hotels_GetHotelInfo_GetHotelInfoQueryResponse } from "../../swagger-types/v1/index.js";
import { getFallbackImageUrl } from "../image-fixtures.js";

export const getHotelInfoResponseMock = () => ({
  default: hotelInfoResponseFake,
});

export const hotelInfoResponseFake: Hotels_GetHotelInfo_GetHotelInfoQueryResponse = {
  hotel: {
    id: 125866,
    externalHotelId: "12222",
    images: [
      {
        largeUrl: getFallbackImageUrl(),
        mediumUrl: getFallbackImageUrl(),
        smallUrl: getFallbackImageUrl(),
        caption: "citizen",
        id: 1901,
        ordinal: 43,
        sources: [],
        main: false,
      },
      {
        largeUrl: getFallbackImageUrl(),
        mediumUrl: getFallbackImageUrl(),
        smallUrl: getFallbackImageUrl(),
        caption: "rumor",
        id: 2862,
        ordinal: 18,
        sources: [],
        main: false,
      },
      {
        largeUrl: getFallbackImageUrl(),
        mediumUrl: getFallbackImageUrl(),
        smallUrl: getFallbackImageUrl(),
        caption: "rumor",
        id: 2862,
        ordinal: 18,
        sources: [],
        main: false,
      },
    ],
    location: {
      address: "24839 Gottlieb Landing",
      countryName: "United States of America",
      cityName: "Long Island City",
      countryCode: "US",
      latitude: 40.75253,
      longitude: -73.981316,
      postalCode: "34345",
      stateCode: "ny",
    },
    name: "Andaz 5th Avenue",
    amenities: [
      {
        categoryId: 38,
        categoryName: "Free WiFi",
        categoryTopOrder: 0,
        id: 563,
        name: "Free WiFi",
      },
      {
        categoryId: 34,
        categoryName: "Gym",
        categoryTopOrder: 1,
        id: 187,
        name: "Gym",
      },
      {
        categoryId: 39,
        categoryName: "Air conditioning",
        categoryTopOrder: 1,
        id: 31,
        name: "Air conditioning",
      },
      {
        categoryId: 35,
        categoryName: "Airport shuttle",
        categoryTopOrder: 1,
        id: 812,
        name: "Airport shuttle",
      },
      {
        categoryId: 36,
        categoryName: "Family friendly",
        categoryTopOrder: 1,
        id: 835,
        name: "Family friendly",
      },
      {
        categoryId: 21,
        categoryName: "Pool",
        categoryTopOrder: 1,
        id: 959,
        name: "Pool",
      },
      {
        categoryId: 16,
        categoryName: "Parking",
        categoryTopOrder: 1,
        id: 582,
        name: "Parking",
      },
      {
        categoryId: 32,
        categoryName: "Room service",
        categoryTopOrder: 1,
        id: 333,
        name: "Room service",
      },
      {
        categoryId: 37,
        categoryName: "Spa",
        categoryTopOrder: 1,
        id: 502,
        name: "Spa",
      },
    ],
    starRating: 3.5,
    info: {
      reviewsCount: 260,
      reviewsRatingLevel: "Excellent",
      reviewsRating: "6.9",
      reviewsSummary:
        "Denuo alienus officiis curriculum asperiores decumbo umquam clarus. Tantillus talis ago denique utrum toties vigor tunc caelum callide. Cetera concido comparo saepe cunctatio deinde vergo angulus sunt minus.",
      checkinInstructions:
        "Denuo alienus officiis curriculum asperiores decumbo umquam clarus. Tantillus talis ago denique utrum toties vigor tunc caelum callide. Cetera concido comparo saepe cunctatio deinde vergo angulus sunt minus.",
      checkinTime: "10:00",
      checkoutTime: "11:00",
      hotelDescription:
        "Tolero timor clarus veritatis aegre. Casso cui claudeo adeo audacia crepusculum suppellex at aestus stips. Umerus defluo acies trepide suffragium curis.Tolero timor clarus veritatis aegre. Casso cui claudeo adeo audacia crepusculum suppellex at aestus stips. Umerus defluo acies trepide suffragium curis.Tolero timor clarus veritatis aegre. Casso cui claudeo adeo audacia crepusculum suppellex at aestus stips. Umerus defluo acies trepide suffragium curis.Tolero timor clarus veritatis aegre. Casso cui claudeo adeo audacia crepusculum suppellex at aestus stips. Umerus defluo acies trepide suffragium curis.Tolero timor clarus veritatis aegre. Casso cui claudeo adeo audacia crepusculum suppellex at aestus stips. Umerus defluo acies trepide suffragium curis.",
    },
    reviews: [
      {
        content:
          "Angelus decimus arto argumentum decretum valens constans. Textilis pariatur ara supplanto. Bos curso administratio depereo tumultus coaegresco cena cursim.",
        id: 3173,
        publishedAt: "2024-12-12",
        reviewUrl: "",
        score: 4,
        title:
          "Utroque repellendus textor crinis viduo dolor antepono appositus clibanus. Distinctio deserunt cenaculum officiis tamquam exercitationem tamen excepturi sto currus. Caste vulticulus valetudo coerceo absorbeo congregatio distinctio cilicium defendo.",
        userName: "Dale Moen-Schumm",
      },
    ],
  },
};
